import {
	HardDrive,
	HardDriveDownloadIcon,
	LayoutDashboard,
	Store
} from "lucide-react";
import config from "../../config";
import { ReactComponent as Dashboard } from "./Sidebar/icons/bar-chart-square-02.svg?react";
import { ReactComponent as Package } from "./Sidebar/icons/package.svg?react";
import { ReactComponent as Report } from "./Sidebar/icons/file-07.svg?react";
import { ReactComponent as Users } from "./Sidebar/icons/users-01.svg?react";
import { ReactComponent as Settings } from "./Sidebar/icons/settings-01.svg?react";
import { ReactComponent as Finance } from "./Sidebar/icons/coins-stacked-03.svg?react";
import { ReactComponent as Discount } from "./Sidebar/icons/discount.svg?react";
import { ReactComponent as Cube } from "./Sidebar/icons/cube-02.svg?react";
import { ReactComponent as Menu } from "./Sidebar/icons/menu-01.svg?react";

const menus = [
	{
		id: "dashboard",
		link: "/",
		label: "Дашборд",
		icon: "menu-analytic",
		role: "dashboard",
		NewIcon: Dashboard
	},
	{
		id: "reports",
		label: "Отчеты",
		icon: "menu-report",
		NewIcon: Report,
		children: [
			{
				id: "reports/z",
				link: "/report/z",
				label: "Z - Отчёт",
				role: "z_report"
			},
			{
				id: "reports/order",
				link: "/report/orders",
				label: "Отчёт по заказам",
				role: "monitoring_by_orders"
			},
			// {
			// 	id: "reports/order-table",
			// 	link: "/report/orders-table",
			// 	label: "Отчёт по столам",
			// 	role: "monitoring_by_tables"
			// },
			{
				id: "reports/waiter",
				link: "/report/waiter",
				label: "Отчет по Агентам",
				role: "monitoring_by_waiters"
			},
			{
				id: "reports/cashier",
				link: "/report/cashier",
				label: "Отчет по Кассирам",
				role: "monitoring_by_dishes"
			},
			{
				id: "reports/courier",
				link: "/report/courier",
				label: "Отчет по курьерам",
				role: "monitoring_by_couriers"
			},
			{
				id: "reports/dishes",
				link: "/report/dishes",
				label: "Отчёт по продуктам",
				role: "monitoring_by_dishes"
			},
			{
				id: "reports/returned-dishes",
				link: "/report/returned-dishes",
				label: "Отчет о возвращенных товарах",
				role: "deleted_dishes"
			},
			{
				id: "reports/removed-dishes",
				link: "/report/removed-dishes",
				label: "Отчет об удаленных товарах",
				role: "deleted_dishes"
			},
			{
				id: "reports/debt-credit",
				link: "/reports/debt-credit",
				label: "Дебиторы и кредиторы",
				role: "debt_credit"
			},
			// {
			//     id: "reports/storage-material",
			//     link: "/reports/storage-material",
			//     label: "Материальный отчёт склада",
			// },
			// {
			// 	id: "reports/cashflow",
			// 	link: "/reports/cashflow",
			// 	label: "Денежный поток",
			// 	role: "cashflow"
			// }
		]
	},
	{
		id: "users",
		label: "Пользователи",
		icon: "menu-hr",
		NewIcon: Users,
		children: [
			{
				id: "users-manager",
				label: "Менеджер",
				link: `/users?role=${config.USER_ROLE_MANAGER}`,
				role: "manager"
			},
			{
				id: "users-cashier",
				label: "Кассир",
				link: `/users?role=${config.USER_ROLE_CASHIER}`,
				role: "cashier"
			},
			{
				id: "users-warehouse",
				label: "Завсклад",
				link: `/users?role=${config.USER_ROLE_WAREHOUSE}`,
				role: "warehouse"
			},
			{
				id: "users-courier",
				label: "Курьер",
				link: `/users?role=${config.USER_ROLE_COURIER}`,
				role: "courier"
			},
			{
				id: "users-waiter",
				label: "Агент",
				link: `/users?role=${config.USER_ROLE_WAITER}`,
				role: "waiter"
			},
			{
				id: "users-kitchener",
				label: "Другие сотрудники",
				link: `/users?role=${config.USER_ROLE_KITCHENER}`,
				role: "kitchener"
			},
			{
				id: "users-mono",
				label: "Моноблок",
				link: `/users?role=${config.USER_ROLE_MONO}`,
				role: "mono"
			},
			//   {
			//     id: "attendance-users",
			//     link: "/users/attendance",
			//     title: "attendance",
			//     role: "users",
			//   },
			{
				id: "users-attendance",
				label: "Посещаемость",
				link: `/users/${config.USER_ROLE_ATTENDANCE}`,
				role: "attendance"
			},
			{
				id: "users-logs",
				label: "История входов",
				link: `/users/logs`,
				role: "attendance"
			}
		]
	},
	{
		id: "product",
		label: "Продукт",
		icon: "menu-storage",
		NewIcon: Package,
		children: [
			{
				id: "products",
				link: "/products",
				label: "Список",
			},
			{
				id: "product_options",
				link: "/product-params",
				label: "Параметры",
			},
			{
				id: "product_option_items",
				link: "/settings/product",
				label: "Настроить параметров",
			},
			{
				id: "product_categories",
				link: "/product-categories",
				label: "Категории",
			},
		],
	},
	{
		id: "storages",
		label: "Склад",
		icon: "menu-storage",
		NewIcon: Package,
		children: [
			{
				id: "comings",
				link: "/storage/incomes",
				label: "Приход товаров",
				role: "incomes"
			},
			{
				id: "consumptions",
				link: "/storage/consumption",
				label: "Расход товаров",
				role: "consumptions"
			},
			{
				id: "storages",
				link: "/storages",
				label: "Остаток",
				role: "storages"
			},
			{
				id: "comings",
				link: "/storage/comings",
				label: "Журнал приходов",
				role: "comings"
			},
			{
				id: "transfer",
				link: "/storage/transfers",
				label: "Перемещение",
				role: "transfers"
			},
			{
				id: "adjustments",
				link: "/storage/adjustments",
				label: "Инвентаризация",
				role: "adjustments"
			},
			{
				id: "comings",
				link: "/storage/comings?is_trash=1",
				label: "Отход товаров",
				role: "comings"
			}
		]
	},
	{
		id: "finance",
		label: "Финансы",
		icon: "menu-finance",
		NewIcon: Finance,
		children: [
			{
				id: "transactions",
				link: "/transactions",
				label: "Денежные операции",
				role: "transactions"
			},
			{
				id: "category/income",
				link: "/transactions/categories/income",
				label: "Категория приходов",
				role: "transaction_categories"
			},
			{
				id: "category/expense",
				link: "/transactions/categories/expense",
				label: "Категория расходов",
				role: "transaction_categories"
			}
		]
	},
	{
		id: "marketing",
		label: "Маркетинг",
		icon: "marketing",
		NewIcon: Discount,
		children: [
			{
				id: "stocks",
				link: "/marketing/stocks",
				label: "Акции",
				// role: "marketing_stocks"
				role: "transaction_categories"
			},
			{
				id: "promocodes",
				link: "/marketing/promocodes",
				label: "Промокоды",
				role: "marketing_promocodes"
			},
			{
				id: "sms",
				link: "/marketing/sms",
				label: "СМС",
				role: "transaction_categories"
			},
			{
				id: "gift-cards",
				link: "/marketing/gift-cards",
				label: "Подарочные карты",
				role: "marketing_giftcards"
			},
		],
	},
	// {
	// 	id: "nomenclature",
	// 	label: "Номенклатура",
	// 	icon: "menu-storage",
	// 	NewIcon: Cube,
	// 	cols: 4,
	// 	children: [
	// 		{
	// 			id: "dish",
	// 			link: "/dish",
	// 			label: "Продукт",
	// 			role: "dish"
	// 		},
	// 		{
	// 			id: "materials",
	// 			link: "/materials",
	// 			label: "Сырьё",
	// 			role: "materials"
	// 		},
	// 		{
	// 			id: "semi-finished-products",
	// 			link: "/semi-finished-products",
	// 			label: "Полуфабрикаты",
	// 			role: "semi_finished_products"
	// 		},
	// 		{
	// 			id: "dish-category",
	// 			link: "/dish-categories",
	// 			label: "Категория блюд",
	// 			role: "dish_categories"
	// 		},
	// 		{
	// 			id: "material-category",
	// 			link: `/categories/${config.CATEGORY_MATERIAL}`,
	// 			label: "Категория сырьё",
	// 			role: "material_categories"
	// 		},
	// 		{
	// 			id: "half-product-category",
	// 			link: `/categories/${config.CATEGORY_HALF_FINISHED}`,
	// 			label: "Категория полуфабрикатов",
	// 			role: "semi_finished_product_categories"
	// 		},
	// 		{
	// 			id: "product-category",
	// 			link: `/categories/${config.CATEGORY_PRODUCT}`,
	// 			label: "Категория реализации",
	// 			role: "implementation_categories"
	// 		}
	// 	]
	// },
	// {
	// 	id: "menu-cast",
	// 	label: "Меню-каст",
	// 	icon: "menu-cast",
	// 	cols: 4,
	// 	NewIcon: Menu,
	// 	children: [
	// 		{
	// 			id: "mc-devices",
	// 			link: "/mc-devices",
	// 			label: "Устройства",
	// 			role: "mc_devices"
	// 		},
	// 		{
	// 			id: "mc-playlists",
	// 			link: "/mc-playlists",
	// 			label: "Плейлисты",
	// 			role: "mc_playlists"
	// 		},
	// 		{
	// 			id: "banner",
	// 			link: "/banner",
	// 			label: "Баннеры",
	// 			role: "banners"
	// 		}
	// 	]
	// },
	{
		id: "settings",
		label: "Настройки",
		icon: "menu-setting",
		NewIcon: Settings,
		children: [
			{
				id: "counterparties",
				label: "Клиенты",
				icon: "menu-clients",
				link: "/counterparties",
				role: "clients"
			},
			// {
			// 	id: "places",
			// 	link: "/places",
			// 	label: "Место",
			// 	role: "places"
			// },
			{
				id: "payment-types",
				link: "/handbook/payment-types",
				label: "Способ оплаты",
				role: "payment_types"
			},
			{
				id: "units",
				link: "/handbook/units",
				label: "Единица измерения",
				role: "units"
			},
			{
				id: "profile-settings",
				link: "/settings/new-settings",
				label: "Настройка профиля",
				role: "profile"
			},
			{
				id: "printers",
				link: "/settings/printers",
				label: "Настройка принтеров",
				role: "printers"
			},
			{
				id: "printers",
				link: "/settings/cheque-builder",
				label: "Настройка чека",
				role: "printers"
			},
			{
				id: "barcode-constructor",
				link: "/settings/barcode-constructor",
				label: "Конструктор ценников",
				role: "printers"
			},
			{
				id: "tech-help",
				link: "/settings/tech-help",
				label: "Тех. поддержка"
			}
		]
	},
	{
		id: "store",
		link: "/store",
		label: "Магазин",
		icon: "menu-analytic",
		NewIcon: HardDriveDownloadIcon
	}
];

const getMenu = role => {
	return filterMenusByRoles(menus, role);
};

function filterMenusByRoles(menus, userRoles) {
	const allowedRoles =
		userRoles && userRoles.length > 0 && userRoles.map(r => r.role);

	return menus
		.map(menu => {
			// Если есть children
			if (menu.children) {
				const filteredChildren = menu.children.map(child => {
					// Если у child указана роль — проверяем доступ
					if (child.role) {
						return {
							...child,
							isLocked: !allowedRoles.includes(child.role)
						};
					}
					// Если нет роли — показываем
					return { ...child, isLocked: false };
				});

				// Если остались доступные дети — возвращаем
				if (filteredChildren.length > 0) {
					return { ...menu, children: filteredChildren, isLocked: false };
				}

				// Если ни один child не доступен — убираем весь раздел
				return null;
			}

			// Пункты без children
			if (menu.role) {
				return {
					...menu,
					isLocked: !allowedRoles.includes(menu.role)
				};
			}

			// Пункты без роли — показываем
			return { ...menu, isLocked: false };
		})
		.filter(Boolean); // Убираем null
}

export default getMenu;
